"use strict";
import { Flex } from "ui/src";
import { Shuffle } from "ui/src/components/icons/Shuffle";
import { zIndexes } from "ui/src/theme";
import { CurrencyLogo, STATUS_RATIO } from "components/CurrencyLogo/CurrencyLogo";
import { TransactionSummaryNetworkLogo } from "components/CurrencyLogo/NetworkLogo";
import { TokenLogo } from "components/CurrencyLogo/TokenLogo";
import { WRAPPED_NATIVE_CURRENCY } from "constants/topazTokenList";
import { UniverseChainId } from "features/chains/types";
function isBnbOrWbnb(info) {
  if (!info?.currency) return false;
  const { currency } = info;
  const wrapped = WRAPPED_NATIVE_CURRENCY[currency.chainId];
  if (!wrapped) return false;
  if (currency.isNative) return true;
  if (!("address" in currency) || !currency.address) return false;
  return currency.address.toLowerCase() === wrapped.address.toLowerCase();
}
function shouldDemoteBnb(input, output) {
  return isBnbOrWbnb(output) && !isBnbOrWbnb(input);
}
export function SplitLogo({
  size,
  inputCurrencyInfo,
  outputCurrencyInfo,
  inputLogoUrl,
  outputLogoUrl,
  chainId,
  customIcon
}) {
  const iconSize = size / 2;
  const networkLogo = chainId && chainId !== UniverseChainId.Mainnet ? <TransactionSummaryNetworkLogo chainId={chainId} size={size * STATUS_RATIO} /> : void 0;
  const demoteBnb = shouldDemoteBnb(inputCurrencyInfo, outputCurrencyInfo);
  const inputBlock = <Flex
    key="input"
    display={inputLogoUrl || inputCurrencyInfo ? "flex" : "none"}
    testID="input-currency-logo-container"
    width={iconSize}
    ml={demoteBnb ? -iconSize / 3 : void 0}
  >
      {inputLogoUrl ? <TokenLogo hideNetworkLogo url={inputLogoUrl} chainId={chainId ?? void 0} size={size} /> : <CurrencyLogo hideNetworkLogo currencyInfo={inputCurrencyInfo} size={size} />}
    </Flex>;
  const outputBlock = <Flex
    key="output"
    display={outputLogoUrl || outputCurrencyInfo ? "flex" : "none"}
    testID="output-currency-logo-container"
    width={iconSize}
    ml={demoteBnb ? void 0 : -iconSize / 3}
  >
      {outputLogoUrl ? <TokenLogo hideNetworkLogo url={outputLogoUrl} chainId={chainId ?? void 0} size={size} /> : <CurrencyLogo hideNetworkLogo currencyInfo={outputCurrencyInfo} size={size} />}
    </Flex>;
  return <Flex height={size} row>
      {demoteBnb ? outputBlock : inputBlock}
      {demoteBnb ? inputBlock : outputBlock}
      {(customIcon || networkLogo) && <Flex bottom={-4} position="absolute" right={-4} zIndex={zIndexes.mask}>
          {customIcon ?? networkLogo}
        </Flex>}
    </Flex>;
}
export function CombinedLogo({
  size,
  inputCurrencyInfo,
  outputCurrencyInfo,
  inputLogoUrl,
  outputLogoUrl,
  chainId,
  customIcon
}) {
  const iconSize = size || 24;
  const networkLogo = chainId && chainId !== UniverseChainId.Mainnet ? <TransactionSummaryNetworkLogo chainId={chainId} size={size * STATUS_RATIO} /> : void 0;
  const demoteBnb = shouldDemoteBnb(inputCurrencyInfo, outputCurrencyInfo);
  const inputBlock = <Flex
    key="input"
    display={inputLogoUrl || inputCurrencyInfo ? "flex" : "none"}
    testID="input-currency-logo-container"
    width={iconSize}
    ml={demoteBnb ? -iconSize / 3 : void 0}
  >
      {inputLogoUrl ? <TokenLogo hideNetworkLogo url={inputLogoUrl} chainId={chainId ?? void 0} size={size} /> : <CurrencyLogo hideNetworkLogo currencyInfo={inputCurrencyInfo} size={size} />}
    </Flex>;
  const outputBlock = <Flex
    key="output"
    display={outputLogoUrl || outputCurrencyInfo ? "flex" : "none"}
    testID="output-currency-logo-container"
    width={iconSize}
    ml={demoteBnb ? void 0 : -iconSize / 3}
  >
      {outputLogoUrl ? <TokenLogo hideNetworkLogo url={outputLogoUrl} chainId={chainId ?? void 0} size={size} /> : <CurrencyLogo hideNetworkLogo currencyInfo={outputCurrencyInfo} size={size} />}
    </Flex>;
  return <Flex height={size} row>
      {demoteBnb ? outputBlock : inputBlock}
      {demoteBnb ? inputBlock : outputBlock}
      {(customIcon || networkLogo) && <Flex bottom={-4} position="absolute" right={-4} zIndex={zIndexes.mask}>
          {customIcon ?? networkLogo}
        </Flex>}
    </Flex>;
}
export const BridgeIcon = <Flex
  testID="bridge-icon"
  borderColor="$surface1"
  borderWidth="$spacing2"
  borderRadius="$roundedFull"
  overflow="hidden"
  backgroundColor="$statusSuccess"
  p="$spacing1"
>
    <Shuffle size="$icon.12" color="$surface1" backgroundColor="$statusSuccess" />
  </Flex>;
